import { Action, createReducer, on } from '@ngrx/store';

import * as SceneryActions from './scenery.actions';

import { Scenery } from 'src/app/model/scenery';
import { SceneryStep } from 'src/app/model/scenery-step';
import { SceneryAction } from 'src/app/model/scenery-action';


export interface State {
    sceneryAdded: number;
    sceneryAdding: boolean;
    sceneriesLoading: boolean;
    sceneryEditing: boolean;
    sceneryEdited: boolean;
    sceneries: Scenery[];
    stepAdded: boolean;
    stepAdding: boolean;
    stepEdited: boolean;
    stepEditing: boolean;
    steps: SceneryStep[];
    actions: SceneryAction[];
}
export const initialState: State = {
    sceneryAdded: 0,
    sceneryAdding: false,
    sceneriesLoading: false,
    sceneryEditing: false,
    sceneryEdited: false,
    sceneries: [],
    stepAdded: false,
    stepAdding: false,
    stepEdited: false,
    stepEditing: false,
    steps: [],
    actions: [],
};

const sceneryReducer = createReducer(
    initialState,
    on(SceneryActions.getSceneries, (state) => ({ ...state, sceneriesLoading: true })),
    on(SceneryActions.getSceneriesSuccess, (state, payload) => ({
        ...state,
        sceneries: payload.sceneries,
        sceneriesLoading: false
    })),
    on(SceneryActions.getSceneriesFailed, (state) => ({ ...state, sceneriesLoading: false })),
    on(SceneryActions.resetSceneryDialog, (state) => ({
        ...state, sceneryAdding: false, sceneryAdded: 0, sceneryEditing: false, sceneryEdited: false
    })),
    on(SceneryActions.addScenery, (state) => ({ ...state, sceneryAdding: true, sceneryAdded: 0 })),
    on(SceneryActions.addScenerySuccess, (state, payload) => {
        const sceneries = [...state.sceneries, payload.scenery];
        return { ...state, sceneries, sceneryAdded: payload.scenery.Id, sceneryAdding: false };
    }),
    on(SceneryActions.addSceneryFailed, (state) => ({ ...state, sceneryAdded: 0, sceneryAdding: false })),
    on(SceneryActions.editScenery, (state) => ({ ...state, sceneryEditing: true, sceneryEdited: false })),
    on(SceneryActions.editScenerySuccess, (state, payload) => {
        const filtered = state.sceneries.filter(scen => scen.Id !== payload.scenery.Id);
        return { ...state,
            sceneries: [...filtered, payload.scenery],
            sceneryEdited: true, sceneryEditing: false };
    }),
    on(SceneryActions.editSceneryFailed, (state) => ({ ...state, sceneryEdited: false, sceneryEditing: false })),
    on(SceneryActions.deleteScenerySuccess, (state, payload) => {
        const newScenerys = state.sceneries.filter((scenery) => scenery.Id !== payload.sceneryId);
        return { ...state, sceneries: newScenerys };
    }),
    on(SceneryActions.getStepsSuccess, (state, payload) => ({ ...state, steps: payload.steps })),
    on(SceneryActions.resetStepDialog, (state) => ({
        ...state, stepAdding: false, stepAdded: false, stepEditing: false, stepEdited: false
    })),
    on(SceneryActions.addStep, (state) => ({ ...state, stepAdded: false })),
    on(SceneryActions.addStepSuccess, (state, payload) => ({
        ...state,
        steps: [...state.steps, payload.step],
        stepAdded: true
    })),
    on(SceneryActions.addStepFailed, (state) => ({ ...state, stepAdded: false })),
    on(SceneryActions.editStep, (state) => ({ ...state, stepEdited: false, stepEditing: true })),
    on(SceneryActions.editStepSuccess, (state, payload) => {
        const newSteps = state.steps.filter(st => st.Id !== payload.step.Id);
        return {...state, steps: [...newSteps, payload.step], stepEdited: true, stepEditing: false};
    }),
    on(SceneryActions.editStepFailed, (state) => ({ ...state, stepEdited: false, stepEditing: false })),
    on(SceneryActions.getActionsSuccess, (state, payload) => ({ ...state, actions: payload.actions })),
    on(SceneryActions.addActionSuccess, (state, payload) => ({
        ...state,
        actions: [...state.actions, payload.action],
        stepAdded: true
    })),
    on(SceneryActions.deleteStepSuccess, (state, payload) => ({
        ...state,
        steps: state.steps.filter(step => step.Id !== payload.stepId),
        actions: state.actions.filter(action => action.StepId !== payload.stepId)
    })),
    on(SceneryActions.reorderStepsSuccess, (state, payload) => {
        const sceneryId = payload.steps[0].SceneryId;
        const filteredSteps = state.steps.filter((step) => step.SceneryId !== sceneryId);
        return {
            ...state,
            steps: [...filteredSteps, ...payload.steps]
        };
    }),
);

export const reducer = (state: State | undefined, action: Action): State => sceneryReducer(state, action);
